
import { useEffect, useState } from 'preact/hooks';
const DOMAIN = `https://secret-list.io.mlj130.com/lt/live-theme`;
import { Tabs, CapsuleTabs, SpinLoading, List, InfiniteScroll, Empty } from 'antd-mobile';
import Loading from './Loading';
import SearchBar from './Search';
import request from '../base/request';
import Product from './Product';

const Base = ({ url }) => {
    const [todayCategory, setTodayCategory] = useState([]);
    const [todayList, setTodayList] = useState([]);
    const [todayLoading, setTodayLoading] = useState(false);
    const [todayCurrentTab, setTodayCurrentTab] = useState('0');
    const [todayHasMore, setTodayHasMore] = useState(false);
    const [empty, setEmpyty] = useState(false);
    const requestTodayList = async (page = 1, keyword = '') => {
        setTodayLoading(true);
        const { data, err } = await request(DOMAIN + `/${url}?category_id=${todayCurrentTab}&page=${page}&keyword=${keyword}`, { method: 'GET' });
        if (err) return;
        setTodayLoading(false);
        if (!data.data.list) {
            setEmpyty(true);
            return;
        }
        setTodayHasMore(data.data.hasMore);
        setTodayList(page === 1 ? data.data.list : [...todayList, ...data.data.list]);
    }
    useEffect(async () => {
        setTodayList([]);
        requestTodayList();
    }, [todayCurrentTab]);
    useEffect(async () => {
        setTodayLoading(true);
        const { data, err } = await request(DOMAIN + `/${url}-category`, { method: 'GET' });
        setTodayLoading(false);
        if (err) return;
        if (Object.keys(data.data).length < 1) return;
        const tc = Object.keys(data.data).map(i => ({ key: i, name: data.data[i] }));
        setTodayCategory(tc);
    }, []);

    const loadMore = () => {
        if (todayLoading) return;
        requestTodayList(todayList.length / 10 + 1);
    }

    const onSearch = (e) => {
        setTodayList([]);
        requestTodayList(1, e)
    }
    const onClear = () => {
        setTodayList([]);
        requestTodayList(1);
    }
    if (empty) return <Empty style={{ padding: '64px 0' }} description=' 暂无商品 ' />
    return (
        <>
            <SearchBar onSearch={onSearch} onClear={onClear} />
            <CapsuleTabs activeKey={todayCurrentTab} onChange={setTodayCurrentTab}>
                {
                    todayCategory.map(i => <CapsuleTabs.Tab title={i.name} key={i.key} />)
                }
            </CapsuleTabs>
            {
                (todayLoading && todayList.length === 0) ? <Loading /> :

                    <>
                        <List>{todayList.map((i, index) => <List.Item style={{ '--padding-left': '0px', '--padding-right': '0px' }} key={index}><Product {...i} /></List.Item>)}</List>
                        <InfiniteScroll loadMore={loadMore} hasMore={todayHasMore} />
                    </>
            }

        </>
    )
}

export default Base;